import { createContext, FC, ReactNode, useContext, useState } from 'react'
import ChristmasDeliveryDate from 'types/ChristmasDeliveryDates'
import { FooterData, NavigationHeader, TopBanner } from './LinkContext'
import { Product } from 'types/Product'
import PaymentOption from 'types/PaymentOption'

type BackendContextType = {
  navHeaders: NavigationHeader[]
  topBanners: TopBanner[]
  footerData: FooterData
  productInfo: Product[]
  setProductInfo: (products: Product[]) => void
  paymentOptions: PaymentOption[]
  setPaymentOptions: (paymentOptions: PaymentOption[]) => void
  christmasDeliveryDates: ChristmasDeliveryDate
  setChristmasDeliveryDates: (dates: ChristmasDeliveryDate) => void
}

const BackendContextDefaultValues: BackendContextType = {
  navHeaders: [],
  topBanners: [],
  footerData: null,
  productInfo: [],
  setProductInfo: () => {},
  paymentOptions: [],
  setPaymentOptions: () => {},
  christmasDeliveryDates: null,
  setChristmasDeliveryDates: () => {},
}

const BackendContext = createContext<BackendContextType>(BackendContextDefaultValues)

export function useBackend(): BackendContextType {
  return useContext(BackendContext)
}

type PropTypes = {
  children: ReactNode
  navHeaders: NavigationHeader[]
  topBanners: TopBanner[]
  footerData: FooterData
  initialProductInfo: Product[]
  initialPaymentOptions: PaymentOption[]
  initialChristmasDeliveryDates: ChristmasDeliveryDate
}

export const BackendProvider: FC<PropTypes> = ({ children, initialProductInfo, initialPaymentOptions, initialChristmasDeliveryDates }) => {
  const [productInfo, setProductInfo] = useState<Product[]>(initialProductInfo || [])
  const [paymentOptions, setPaymentOptions] = useState<PaymentOption[]>(initialPaymentOptions || [])
  const [christmasDeliveryDates, setChristmasDeliveryDates] = useState<ChristmasDeliveryDate>(initialChristmasDeliveryDates || null)

  const value = {
    navHeaders: [],
    topBanners: [],
    footerData: null,
    productInfo,
    setProductInfo,
    paymentOptions,
    setPaymentOptions,
    christmasDeliveryDates,
    setChristmasDeliveryDates,
  }

  return (
    <>
      <BackendContext.Provider value={value}>{children}</BackendContext.Provider>
    </>
  )
}
